import request, { operateRequest, uatRequest } from '@/utils/axios';
import axios from 'axios';
import { useHostConfigStore } from '@/store/hostConfigStore';

const ezoneHeaders = {
  access_token: '70271b1cb24445cd8c012c67fae521321691667164552',
  'x-company-name': 'Zelos',
};

export const getUserPermission = () =>
  request.get<any, API.ResourceInfoType[]>(
    '/manage/auth/user/current/resource',
    {
      baseURL: useHostConfigStore().host_config.VITE_DATA_PUB_HOST,
    },
  );

export const reportProblem = (data: any) =>
  operateRequest.post('/zelos-service/problemReport', data, {
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST
  });

export const checkToken = async () =>
  axios.post(
    `${useHostConfigStore().host_config.VITE_AUTH_HOST}/oauth/check_token`,
    {},
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      params: {
        token: localStorage.getItem('access_token'),
      },
    },
  );

export const getTakeoverReasonList = () =>
  operateRequest.get(
    '/admin-server/dataDictionary?type=VEHICLE_TAKEOVER_REASON&pageSize=0',
    {
      baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
    },
  );

export const getVehicleStatus = (vehicleName: string, ts: number) =>
  operateRequest.get(`/playback-server/playback/getStatus`, {
    params: {
      vehicleName,
      ts,
    },
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });

// 数据中心：获取车辆最近一次远程控制记录（用于仪表盘接管来源展示）
export const getLatestRemoteControl = (data: {
  vehicleName: string;
  operateTimestamp: number;
}) =>
  operateRequest.post(
    '/dap-server/busVehicleOperationLog/latestRemoteControl',
    data,
    {
      baseURL: useHostConfigStore().host_config.VITE_DATACENTER_HOST,
    },
  );

// 数据中心：获取车辆操作日志（一键挪车、远程接管等），用于进度条旗子标注
export const getVehicleOperationLog = (data: {
  vehicleName: string;
  startTime: string;
  endTime: string;
  instructionTypeCode: string[];
}) =>
  operateRequest.post('/api/v1/zelos/vehicle/operation/log/list', data, {
    baseURL: useHostConfigStore().host_config.VITE_DATACENTER_HOST,
    headers: {
      // 数据中心对外开放接口鉴权
      'x-api-key': 's8u9p9adf2jkrb23u09dvo90nkjfsadou3hl',
    },
  });

export const createEzoneCard = (params: any, draftId?: string) =>
  request.post(
    `${useHostConfigStore().host_config.VITE_DATA_PUB_HOST}/charts/fe-proxy/commonProxy`,
    {
      url: `https://ezone.zelostech.com.cn/v1/ezproject/ezProject/card?projectId=694260981820354560&sendEmail=false&draftId=${draftId}`,
      body: params,
      method: 'post',
      headers: ezoneHeaders,
    },
  );

export const setCardContent = (params: any, cardId: string) =>
  request.post(
    `${useHostConfigStore().host_config.VITE_DATA_PUB_HOST}/charts/fe-proxy/commonProxy`,

    {
      url: `https://ezone.zelostech.com.cn/v1/ezproject/ezProject/card/${cardId}/fields`,
      body: params,
      method: 'put',
      headers: ezoneHeaders,
    },
  );

export const createDraft = () =>
  request.post(
    `${useHostConfigStore().host_config.VITE_DATA_PUB_HOST}/charts/fe-proxy/commonProxy`,
    {
      url: 'https://ezone.zelostech.com.cn/v1/ezproject/ezProject/card/draft?projectId=694260981820354560',
      method: 'post',
      headers: ezoneHeaders,
    },
  );

export const deleteDraft = (draftId: string, imageId: string) =>
  request.post(
    `${useHostConfigStore().host_config.VITE_DATA_PUB_HOST}/charts/fe-proxy/commonProxy`,
    {
      url: `https://ezone.zelostech.com.cn/v1/ezproject/ezProject/card/${draftId}/attachment/${imageId}?isDraft=true`,
      method: 'delete',
      headers: ezoneHeaders,
    },
  );

export const getCarList = () =>
  operateRequest.get('/admin-server/vehicle/all?pageNumber=1&pageSize=0', {
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST
  });

export async function getPlayInfo(params: any) {
  let res = await operateRequest.get('/playback-server/playback/getPlayInfo', {
    params,
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });
  return res
}

export function uploadImage(file: any) {
  return operateRequest.post('/extra-server/view/problem/attachment', file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });
}


export const getVehicleInfo = (vehicleName: string) =>
  operateRequest.get(
    '/admin-server/vehicle/management/detail?name=' + vehicleName,
    {
      baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
    },
  );

//wswsws
export async function getVehicleRecordMiss(vehicleName: string, start: number, origin: string) {
  let res = await operateRequest.get(
    `/playback-server/playlist/load?vehicle=${vehicleName}&start=${start}`,
    {
      baseURL: origin == "beijing1" ? useHostConfigStore().host_config.VITE_GATEWAY_HOST_BJ : useHostConfigStore().host_config.VITE_GATEWAY_HOST,
    },
  );
  return res;
}

///wswsws
/**
 * 根据车号和选择的时间获取其可播放的列表
 * @param vehicleName 
 * @returns 
 */
export async function getVehiclePlayList(vehicleName: string, start?: number, end?: number) {
  const baseUrl = `/playback-server/playlist/search?vehicle=${vehicleName}`;
  const url = (start !== undefined && end !== undefined)
    ? `${baseUrl}&start=${start}&end=${end}`
    : baseUrl;

  let res = await operateRequest.get(url, {
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });
  res?.data?.forEach(item => {
    item.startU = item.start
    item.endU = item.end
    item.start = Math.floor(new Date(item.start).getTime() / 1000);
    item.end = Math.floor(new Date(item.end).getTime() / 1000);
  })
  return res;
};


export const getVehiclePlayList_old = (vehicleName: string, start?: number, end?: number) => {
  const baseUrl = `/playback-server/session/playlist?vehicle=${vehicleName}`;
  const url = (start !== undefined && end !== undefined)
    ? `${baseUrl}&start=${start}&end=${end}`
    : baseUrl;

  return operateRequest.get(url, {
    baseURL: useHostConfigStore().host_config.VITE_GATEWAY_HOST,
  });
};

// 获取alarmCode列表
export const getAlarmCodeList = (params: any) => {
  return operateRequest.post('/dap-server/dpOwlVehicle/query', params, {
    baseURL: useHostConfigStore().host_config.VITE_DATA_PUB_HOST,
  });
}

// 获取车辆列表-新
export const getVehicleList = (params: any) => {
  return operateRequest.post('/dap-server/vehicle/searchByName', params, {
    baseURL: useHostConfigStore().host_config.VITE_DATA_PUB_HOST,
  });
}

// 获取freeArea
export const getFreeArea = (params: any) => {
  return operateRequest.get('/taskApi/task/freeArea/findByWgs84', {
    params: {
      lon: params.lon,
      lat: params.lat,
    },
    baseURL: useHostConfigStore().host_config.VITE_GATEWAYDATA_HOST,
  });
};